export const generateRandomColor = (): string => {
  const color = Math.floor(Math.random() * 16777215).toString(16);
  return `#${color.padStart(6, '0')}`;
};

export const formatValue = (value: number, decimals: number = 2): string => {
  if (value === undefined || value === null) return 'N/A';

  if (value > 1024 * 1024 * 1024) {
    return `${(value / (1024 * 1024 * 1024)).toFixed(decimals)} GB`;
  } else if (value > 1024 * 1024) {
    return `${(value / (1024 * 1024)).toFixed(decimals)} MB`;
  } else if (value > 1024) {
    return `${(value / 1024).toFixed(decimals)} KB`;
  }
  
  if (value >= 0 && value <= 1) {
    return `${(value * 100).toFixed(decimals)}%`;
  }
  
  if (value > 1000000) {
    return `${(value / 1000000).toFixed(decimals)}M`;
  } else if (value > 1000) {
    return `${(value / 1000).toFixed(decimals)}K`;
  }
  
  return value.toFixed(decimals);
};

export const getThresholdColor = (
  value: number, 
  thresholds: { warning: number; critical: number }
): string => {
  if (value >= thresholds.critical) return '#ff0000'; // Vermelho
  if (value >= thresholds.warning) return '#ffcc00';  // Amarelo
  return '#00cc00'; // Verde
};

export const logLevelColors: Record<string, string> = {
  error: '#FF5252',
  warn: '#FFB74D',
  warning: '#FFB74D',
  info: '#4FC3F7',
  debug: '#9CCC65',
  trace: '#B39DDB',
  default: '#9E9E9E',
  unknown: '#BDBDBD',
};

export const getLogLevelColor = (level: string): string => {
  const lowerLevel = String(level).toLowerCase();
  return logLevelColors[lowerLevel] || logLevelColors.default;
};